import { cacheKeys, Issue, useIssue } from '@gripp/shared-logic';
import {
  LoadingIndicator,
  RoutineExecutionProps,
  RoutineForm,
  SlideAction,
  useSlideLayout
} from '@gripp/shared-ui';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import { IssueEditRoutineLoader } from '../../../../../libs/shared-ui/src/components/issue/issueEditRoutineLoader';

export const ActivityReviseColumn = () => {
  const { issueId } = useParams();
  const { issue: issueData, isLoading } = useIssue(issueId ?? '');
  const issue = issueData as unknown as Issue | undefined;
  const { onSlideChange } = useSlideLayout();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [routineExecutionProps, setRoutineExecutionProps] =
    useState<RoutineExecutionProps | null>(null);
  const [isLoadingRoutine, setIsLoadingRoutine] = useState(true);

  const handleBack = async () => {
    await onSlideChange(SlideAction.PREV);
    navigate(-1);
  };

  if (isLoading || !issue) {
    return <LoadingIndicator />;
  }

  return (
    <View style={{ flex: 1 }}>
      <IssueEditRoutineLoader
        isEditRoutineLoader={isLoadingRoutine}
        issue={issue}
        currentTitle={issue.title}
        onRoutineEdition={(props) => {
          setIsLoadingRoutine(false);
          setRoutineExecutionProps(props);
        }}
        onAlertWorkflowDetected={() => {
          setIsLoadingRoutine(false);
          handleBack();
        }}
      />
      {isLoadingRoutine || !routineExecutionProps ? (
        <LoadingIndicator />
      ) : (
        <RoutineForm
          {...routineExecutionProps}
          onCompleted={async () => {
            await queryClient.invalidateQueries({
              queryKey: cacheKeys('issueMessage').all,
              exact: false,
            });
            handleBack();
          }}
          onCancel={handleBack}
          topBar={() => <></>}
          isIssueEditRoutine={true}
        />
      )}
    </View>
  );
};
